import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { CompaniesTable } from '~/components/settings/masterData/company/CompaniesTable';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/masterdata/companies/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata/companies',
    ...routeParams,
  }),
  component: CompaniesTable,
  validateSearch,
});

export const MASTERDATA_COMPANIES = buildRouteExport({ Route, ...routeParams });
